import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/lib/utils"

function Tabs({
  className,
  ...props
}) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      className={cn("flex flex-col gap-2 rounded-sm", className)}
      {...props} />
  );
}

function TabsList({
  className,
  ...props
}) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        // Use your color variables for background and text
        "bg-(--color-muted) text-(--color-muted-foreground) rounded-sm inline-flex h-9 w-full sm:w-fit min-w-0 items-center justify-center p-1 gap-1 sm:gap-2",
        className
      )}
      {...props} />
  );
}

function TabsTrigger({
  className,
  ...props
}) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        // Use your color variables for active, hover, and focus states
        "data-[state=active]:bg-(--neutral-50) data-[state=active]:text-(--color-primary) rounded-sm font-semibold focus-visible:border-(--color-ring) focus-visible:ring-(--color-ring)/50 focus-visible:outline-(--color-ring) inline-flex h-[calc(100%-4px)] flex-1 sm:flex-none min-w-0 items-center justify-center gap-1.5 border-4 border-transparent px-1.5 sm:px-2 py-1 text-xs sm:text-sm text-(--neutral-950) whitespace-nowrap transition-[color,box-shadow,background-color] focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:shadow-sm [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        className
      )}
      {...props} />
  );
}

function TabsContent({
  className,
  ...props
}) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn(
        "flex-1 outline-none data-[state=inactive]:hidden",
        className
      )}
      {...props} />
  );
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
